import {
	getOrderList,
	getOrderByCon,
	getOutOrderByCon,
	printOrd,
	getReOrdDetByPage,
	getVisitorsum,
	getVisitormenupagem,
	getVisitorflowdetailpage,
	getDeliveryDetail,
	getUnusualOrd,
	cancelOrder,
	cancelOrderbook,
	getBaocanOrd,
	getBaocantimeOrd,
	deductionOrd,
	bufentuikuan,
	shenhetuikuan,
	getHexiaopage,
	getRechargerefund,
	getOrdrefund,
	getShenheOrderByCon,
	getOrdbukourefund,
	getNgOrdInfo,
	getOrdSum,
	getKsgljOrdInfo,
	getKsgljOrdSum,
	getKsgljGoodssum
} from '@/api/odercenter'

const state = {}
const mutations = {}

const actions = {
	getShenheOrderByCon ({}, data) {
		return new Promise((resolve, reject) => {
			getShenheOrderByCon(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	shenhetuikuan ({}, data) {
		return new Promise((resolve, reject) => {
			shenhetuikuan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	bufentuikuan ({}, data) {
		return new Promise((resolve, reject) => {
			bufentuikuan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	deductionOrd ({}, data) {
		return new Promise((resolve, reject) => {
			deductionOrd(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	cancelOrderbook ({}, data) {
		return new Promise((resolve, reject) => {
			cancelOrderbook(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	cancelOrder ({}, data) {
		return new Promise((resolve, reject) => {
			cancelOrder(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrderList ({}, data) {
		return new Promise((resolve, reject) => {
			getOrderList(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOutOrderByCon ({}, data) {
		return new Promise((resolve, reject) => {
			getOutOrderByCon(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrderByCon ({}, data) {
		return new Promise((resolve, reject) => {
			getOrderByCon(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	printOrd ({}, data) {
		return new Promise((resolve, reject) => {
			printOrd(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getVisitorflowdetailpage ({}, data) {
		return new Promise((resolve, reject) => {
			getVisitorflowdetailpage(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getVisitorsum ({}, data) {
		return new Promise((resolve, reject) => {
			getVisitorsum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getVisitormenupagem ({}, data) {
		return new Promise((resolve, reject) => {
			getVisitormenupagem(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getReOrdDetByPage ({}, data) {
		return new Promise((resolve, reject) => {
			getReOrdDetByPage(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getDeliveryDetail ({}, data) {
		return new Promise((resolve, reject) => {
			getDeliveryDetail(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getUnusualOrd ({}, data) {
		return new Promise((resolve, reject) => {
			getUnusualOrd(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBaocanOrd ({}, data) {
		return new Promise((resolve, reject) => {
			getBaocanOrd(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getBaocantimeOrd ({}, data) {
		return new Promise((resolve, reject) => {
			getBaocantimeOrd(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getHexiaopage ({}, data) {
		return new Promise((resolve, reject) => {
			getHexiaopage(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRechargerefund ({}, data) {
		return new Promise((resolve, reject) => {
			getRechargerefund(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrdrefund ({}, data) {
		return new Promise((resolve, reject) => {
			getOrdrefund(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrdbukourefund ({}, data) {
		return new Promise((resolve, reject) => {
			getOrdbukourefund(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getNgOrdInfo ({}, data) {
		return new Promise((resolve, reject) => {
			getNgOrdInfo(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getOrdSum ({}, data) {
		return new Promise((resolve, reject) => {
			getOrdSum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getKsgljOrdInfo ({}, data) {
		return new Promise((resolve, reject) => {
			getKsgljOrdInfo(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getKsgljOrdSum ({}, data) {
		return new Promise((resolve, reject) => {
			getKsgljOrdSum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getKsgljGoodssum ({}, data) {
		return new Promise((resolve, reject) => {
			getKsgljGoodssum(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
